<template>
    <div class="work-info">
        <div>
            <div class="shadow">
                <div style="display: flex;align-items: flex-end;">
                    <span class="d-title">工作信息</span>
                    <span style="flex: 1;text-align: right;" class="d-edit" @click="isEdit = !isEdit">编辑</span>
                </div>
                <div style="margin-top: 0.2rem;">
                    <div style="background-color: #909399;height: 1px;width: 100%;"></div>
                </div>
                <div style="margin-top: 0.2rem;" id="b-content">
                    <div v-if="!isEdit" style="padding: 0.1rem 0 0.1rem 0;">
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">员工类型:</el-col>
                            <el-col :span="7" class="col-n col" v-if="workInfoForm.type === 1">全职</el-col>
                            <el-col :span="7" class="col-n col" v-else-if="workInfoForm.type === 2">兼职</el-col>
                            <el-col :span="7" class="col-n col" v-else></el-col>
                            <el-col :span="5" class="col">员工状态:</el-col>
                            <el-col :span="7" class="col-n col" v-if="workInfoForm.status === 1">正式</el-col>
                            <el-col :span="7" class="col-n col" v-else-if="workInfoForm.status === 2">试用</el-col>
                            <el-col :span="7" class="col-n col" v-else></el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">试用期(月):</el-col>
                            <el-col :span="7" class="col-n col">{{ workInfoForm.probation }}</el-col>
                            <el-col :span="5" class="col">实际转正日期<el-tooltip effect="dark" content="「员工状态」修改为正式时自动产生"
                                    placement="top">
                                    <i class="el-icon-info" style="color: #F56C6C;"></i>
                                </el-tooltip>:</el-col>
                            <el-col :span="7" class="col-n col">{{ workInfoForm.actual_probation_date }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">岗位职级:</el-col>
                            <el-col :span="7" class="col-n col">{{ workInfoForm.position_level }}</el-col>
                            <el-col :span="5" class="col">计划转正日期<el-tooltip effect="dark" content="系统根据「试用期」自动计算,以手动输入为主"
                                    placement="top">
                                    <i class="el-icon-info" style="color: #F56C6C;"></i>
                                </el-tooltip>:</el-col>
                            <el-col :span="7" class="col-n col">{{ workInfoForm.planned_probation_date }}</el-col>
                        </el-row>
                    </div>
                    <div v-else>
                        <el-form ref="workInfoForm" :model="workInfoForm" label-width="115px" size="medium">
                            <el-form-item label="员工类型">
                                <el-select v-model="workInfoForm.type" placeholder="请选择" style="width: 100%" clearable
                                    filterable size="medium">
                                    <el-option :value="1" label="全职">
                                        全职
                                    </el-option>
                                    <el-option :value="2" label="兼职">
                                        兼职
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="员工状态">
                                <el-select v-model="workInfoForm.status" placeholder="请选择"
                                    style="width: 100%" clearable filterable size="medium">
                                    <el-option :value="1" label="正式">
                                        正式
                                    </el-option>
                                    <el-option :value="2" label="试用">
                                        试用
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="试用期(月)">
                                <el-input v-model.trim="workInfoForm.probation" clearable type="number"></el-input>
                            </el-form-item>
                            <!-- <el-form-item>
                                <template slot="label">
                                    <span>实际转正日期</span>
                                    <el-tooltip effect="dark" content="「员工状态」修改为正式时自动产生" placement="top">
                                        <i class="el-icon-info" style="color: #F56C6C;"></i>
                                    </el-tooltip>
                                </template>
                                <el-date-picker v-model="workInfoForm.actual_probation_date" type="date" unlink-panels
                                    value-format="yyyy-MM-dd" style="width: 100%" size="medium">
                                </el-date-picker>
                            </el-form-item> -->
                            <el-form-item label="岗位职级">
                                <el-input v-model.trim="workInfoForm.position_level" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="计划转正日期">
                                <el-date-picker v-model="workInfoForm.planned_probation_date" type="date" unlink-panels
                                    value-format="yyyy-MM-dd" style="width: 100%" size="medium">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item size="medium">
                                <el-button type="primary" @click="onSubmit">提交</el-button>
                                <el-button @click.native="isEdit = !isEdit">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { common } from '../../../../static/mixins/common'
export default {
    name: 'WorkInfo',
    mixins: [common],
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        }
    },
    data() {
        return {
            workInfoForm: {
                type: '',
                status: '',
                probation: '',
                actual_probation_date: '',
                position_level: '',
                planned_probation_date: ''
            },
            isEdit: false,
            adminuserId: '',
            adminuserName: ''
        }
    },
    methods: {
        onSubmit() {
            this.workInfoForm.admin_user_id = this.adminuserId
            this.$axios.put('api/api3_update_workinfo', this.workInfoForm).then(({ data }) => {
                if (data.code === 200) {
                    this.workInfoForm.actual_probation_date = data.data['actual_probation_date']
                    this.workInfoForm.planned_probation_date = data.data['planned_probation_date']
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        getAdminUserWorkInfo(admin_user_id) {
            this.resetForm()
            this.ysyMAdminUserWorkInfoOptions = []
            this.ysyMGetAdminUserWorkInfo(admin_user_id)
        },
        resetForm() {
            this.workInfoForm.type = ''
            this.workInfoForm.status = ''
            this.workInfoForm.probation = ''
            this.workInfoForm.actual_probation_date = ''
            this.workInfoForm.position_level = ''
            this.workInfoForm.planned_probation_date = ''
        },
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n, o) {
                this.adminuserId = null
                if (n !== o) {
                    this.adminuserId = n
                    this.getAdminUserWorkInfo(n)
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n, o) {
                if (n !== o) {
                    this.adminuserName = n
                }
            }
        },
        ysyMAdminUserWorkInfoOptions: {
            handler(n, o) {
                if (n !== o) {
                    if (n) {
                        if (n.admin_user_work_info) {
                            this.workInfoForm.type = n.admin_user_work_info.type
                            this.workInfoForm.status = n.admin_user_work_info.status
                            this.workInfoForm.probation = n.admin_user_work_info.probation
                            this.workInfoForm.actual_probation_date = n.admin_user_work_info.actual_probation_date
                            this.workInfoForm.position_level = n.admin_user_work_info.position_level
                            this.workInfoForm.planned_probation_date = n.admin_user_work_info.planned_probation_date
                        }
                    }
                }
            },
        },
    }
}
</script>

<style scoped>
.d-title {
    font-size: x-large;
    font-weight: bold;
}

.d-edit {
    font-size: medium;
    font-weight: bold;
    color: #409EFF;
    cursor: pointer;
}

/* .col {
    font-size: larger;
    font-weight: bold;
} */

/* .col-n {
    color: slategrey;
} */

#b-content .el-row {
    margin-bottom: 0.6rem;
}

.shadow {
    padding: 0.3rem 0.6rem;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);
    margin: 0.2rem;
}

.over-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#b-content>>>.el-form-item {
    width: 45% !important;
    display: inline-block !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/authority/UserInfoTab/WorkInfo.vue